import { Injectable, Injector } from '@angular/core';
import { HttpDataService } from 'core/services/http-data.service';
import { Observable } from 'rxjs';

@Injectable()
export class DashboardDataService extends HttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '/dashboard');
  }

  public getRatios(options?: Object): Observable<any> {
    return this.fetchRequest(`${this.baseUrl}/licenses/ratios`, options, null);
  }

  public getBestComments(params: any): Observable<any> {
    return this.fetchRequest(`${this.baseUrl}/licenses/surveys/best-comments`, { ...params });
  }
}
